import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useReducer, useState } from "react";

import { useTranslation } from "react-i18next";
import AppContext from "../../../../Contexts/AppContext";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import SettingsIcon from "@mui/icons-material/Settings";

import CloseIcon from "@mui/icons-material/Close";
import { toggleSnapGuides } from "../../../../../services/MapCore/MapService";

export const SettingsButton = ({ map }) => {
  const { t } = useTranslation("main");
  const { modeOptions } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [enableSnapGuides, setEnableSnapGuides] = useState(
    localStorage.getItem("enableSnapGuides") === "true"
  );

  useEffect(() => {
    if (!localStorage.getItem("enableSnapGuides")) {
      localStorage.setItem("enableSnapGuides", "true");
      setEnableSnapGuides(true);
      // forceUpdate();
    }
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleToggleSnapGuides = () => {
    toggleSnapGuides(map);
    setEnableSnapGuides((curr) => !curr);
    localStorage.setItem("enableSnapGuides", !enableSnapGuides);
  };

  const isMobile = window.innerWidth < 960;

  return (
    <>
      <Tooltip title={t("open_settings")}>
        <IconButton
          sx={{
            display: modeOptions.ADD_POLYGON.length > 0 ? "" : "none",
            opacity: 0.7,
            "&:hover": {
              opacity: 1,
            },
          }}
          onClick={handleOpen}
          className="mapButton"
        >
          <SettingsIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: "1rem",
            borderRadius: "8px",
            maxHeight: "80vh",
            overflowY: "auto",
            maxWidth: "90vw",
          }}
        >
          <div
            style={{
              display: "flex",

              justifyContent: "space-between",
              alignItems: "center",
              gap: "1rem",
              paddingBottom: "1rem",
              position: "relative",
            }}
          >
            {!isMobile && (
              <IconButton
                style={{
                  position: "absolute",
                  right: "0",
                }}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            )}
            <Typography variant="h6" component="h2" gutterBottom>
              {t("settings")}
            </Typography>
          </div>

          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={enableSnapGuides}
                  onChange={() => handleToggleSnapGuides()}
                />
              }
              label={t("toggle_snap_guides")}
            />
          </FormGroup>
        </Box>
      </Modal>
    </>
  );
};
